import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { PageSEO } from './components/PageSEO';
import { OrganizationSchema } from './components/StructuredData';
import { Home } from './pages/Home';
import { Approach } from './pages/Approach';
import { Portfolio } from './pages/Portfolio';
import { Founders } from './pages/Founders';
import { Team } from './pages/Team';
import { Values } from './pages/Values';
import { Updates } from './pages/Updates';
import { Contact } from './pages/Contact';
const seoConfig: Record<string, {
  title: string;
  description: string;
}> = {
  '/': {
    title: 'Vitality Venture Fund | Nature-Inspired Innovation Investing',
    description: "Vitality is a venture fund investing in deep tech and hard tech solutions rooted in biomimicry. Fueling startups built on nature's 3.8 billion years of R&D and modern advancements in tech & AI."
  },
  '/approach': {
    title: 'Our Approach — Biomimicry-Based Investing | Vitality Venture Fund',
    description: "Vitality uses a biomimicry-based filter to identify startups creating essential solutions by applying nature's R&D and modern technology across agriculture, construction, and materials."
  },
  '/portfolio': {
    title: 'Portfolio — Nature-Inspired Startups | Vitality Venture Fund',
    description: "Explore Vitality's portfolio of nature-inspired startups across agriculture, built environment, and consumer products including BOPA, TierraSphere, ReefCycle, and Mothership Materials."
  },
  '/founders': {
    title: 'Founder Story — The Anatomy of Endurance | Vitality Venture Fund',
    description: 'Meet Natalya Wallin, GP & Managing Director of Vitality. A high conviction leader with 10+ years deploying a $75M global fund and completing the Moab 240-mile ultramarathon.'
  },
  '/team': {
    title: 'Team — Multidisciplinary Experts | Vitality Venture Fund',
    description: 'Meet the team behind Vitality — experts in engineering, operations, biology, molecular genetics, and fund management building the future of nature-inspired investing.'
  },
  '/values': {
    title: 'Values — Conviction, Athleticism, Adventure, Connection | Vitality Venture Fund',
    description: "The living principles that guide Vitality's work: Conviction to fuel nature-inspired startups, Athleticism to navigate unknowns, Adventure to explore bold ventures, and Connection across disciplines."
  },
  '/updates': {
    title: 'Updates — News & Events | Vitality Venture Fund',
    description: 'Latest news, press features in USA Today, International Business Times, and CEO Weekly, events, partnerships, and investment announcements from Vitality Venture Fund.'
  },
  '/contact': {
    title: 'Contact Us | Vitality Venture Fund',
    description: "Get in touch with Vitality Venture Fund. Whether you're a founder with a nature-inspired solution or an investor aligned with our thesis, we'd love to connect."
  }
};
// SEO manager that updates meta tags on route change
function SEOManager() {
  const {
    pathname
  } = useLocation();
  const seo = seoConfig[pathname] || seoConfig['/'];
  return <PageSEO title={seo.title} description={seo.description} path={pathname} data-id="element-0" />;
}
// Scroll to top on route change
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <Router data-id="element-1">
      <div className="flex flex-col min-h-screen bg-deepCanopy text-white font-sans selection:bg-vitalityTeal selection:text-deepCanopy" data-id="element-2">
        <ScrollToTop data-id="element-3" />
        <SEOManager data-id="element-4" />
        <OrganizationSchema data-id="element-5" />
        <Navigation data-id="element-6" />
        <main className="flex-grow" data-id="element-7">
          <Routes data-id="element-8">
            <Route path="/" element={<Home data-id="element-10" />} data-id="element-9" />
            <Route path="/approach" element={<Approach data-id="element-12" />} data-id="element-11" />
            <Route path="/portfolio" element={<Portfolio data-id="element-14" />} data-id="element-13" />
            <Route path="/founders" element={<Founders data-id="element-16" />} data-id="element-15" />
            <Route path="/team" element={<Team data-id="element-18" />} data-id="element-17" />
            <Route path="/values" element={<Values data-id="element-20" />} data-id="element-19" />
            <Route path="/updates" element={<Updates data-id="element-22" />} data-id="element-21" />
            <Route path="/contact" element={<Contact data-id="element-24" />} data-id="element-23" />
          </Routes>
        </main>
        <Footer data-id="element-25" />
      </div>
    </Router>;
}